import { BrowserModule } from "@angular/platform-browser";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  MatFormFieldModule,
  MatToolbarModule,
  MatSelectModule,
  MatIconModule
} from "@angular/material";
import { FileUploadModule } from "ng2-file-upload";
import { Ng2DeviceDetectorModule } from "ng2-device-detector";
import { Routes, RouterModule, Router, ActivatedRoute } from "@angular/router";
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { httpLoaderFactory } from "./services/httpLoaderFactory.service";

import { AppComponent } from "./app.component";
import { ProjectService } from "./services/project.service";
import { CommentService } from "./services/comment.service";
import { MapBoxComponent } from "./map-box/map-box.component";
import { ErrorPageComponent } from "./error-page/error-page.component";
import { WelcomeComponent } from './welcome/welcome.component';
import { FormComponent } from './form/form.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { ROUTES } from './app.routes';

@NgModule({
  declarations: [AppComponent, MapBoxComponent, ErrorPageComponent, WelcomeComponent, FormComponent, ConfirmComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    NgbModule.forRoot(), // bootstrap
    BrowserAnimationsModule, // angular material animations module
    MatFormFieldModule,
    MatSelectModule,
    MatToolbarModule,
    MatIconModule,
    FileUploadModule,
    Ng2DeviceDetectorModule.forRoot(),
    HttpClientModule,
    FlexLayoutModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    // With cloudfront and s3 running multiple projects in the same domain, we don't have easy control over the routes, so add hash method to make reloading and direct navigation work
    RouterModule.forRoot(ROUTES, { useHash: true }),
  ],
  providers: [ProjectService, CommentService],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts